// extracted by mini-css-extract-plugin
module.exports = {"person-overview":"PersonOverview_person-overview__n0KoI","personOverview":"PersonOverview_person-overview__n0KoI","backToContainer":"PersonOverview_backToContainer__qpKD_"};